export default "__VITE_ASSET__B9bbb$oK__"